define([
    'lodash',
    'santa-components'
], function (
    _,
    santaComponents
) {
    'use strict';

    const shouldEnablePointerEvents = ({componentViewMode}) => componentViewMode === 'editor';

    const extend = baseClass => {
        class LoginSocialBarPreviewExtension extends baseClass {
            transformRefData(refData) {
                if (shouldEnablePointerEvents(this.props)) {
                    refData[''].style.pointerEvents = 'auto';
                }

                return refData;
            }
        }
        LoginSocialBarPreviewExtension.propTypes = _.defaults({
            componentViewMode: santaComponents.santaTypesDefinitions.RenderFlags.componentViewMode
        }, LoginSocialBarPreviewExtension.propTypes);

        return LoginSocialBarPreviewExtension;
    };

    return extend;
});
